export default "__VITE_ASSET__981a8a25__"